/**
 * Query keys for the participating-parties feature. One root so a write can invalidate every
 * view of the same data (attribute roster, party history, matrix, per-election resolver) at once:
 * a change to one attribute moves all four.
 */
export const ballotKeys = {
	all: ['ballot'] as const,
	cycle: (cycleId: number) => [...ballotKeys.all, 'cycle', cycleId] as const,
	partyCycles: (partyId: number) => [...ballotKeys.all, 'party-cycles', partyId] as const,
	matrix: (filters: { electionTypeId?: number; activeOnly?: boolean }) => [...ballotKeys.all, 'matrix', filters] as const,
	ballotParties: (electionId: number) => [...ballotKeys.all, 'ballot-parties', electionId] as const,
	cycleElections: (cycleId: number) => [...ballotKeys.all, 'cycle-elections', cycleId] as const,
	allParties: () => [...ballotKeys.all, 'all-parties'] as const,
	electionTypes: () => [...ballotKeys.all, 'election-types'] as const,
};
